import { Form } from "ant-design-vue";
import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import {
    createFieldCheckbox,
    createFieldInput,
    createFieldInputNumber,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTemplateBuilder
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { isOperationAndSubStanceTypeMain } from "../request.section";
import { calSubStanceRate } from "./haz-main-sub-stance.logic";

//const Address = defineAsyncComponent(() => import("../../../../../components/address/Address"));
//const CTable = defineAsyncComponent(() => import("../../../../../components/table/CTable"));
const HazMainSubStanceList = defineAsyncComponent(() => import("./HazMainSubStanceList"));
const CSelect = defineAsyncComponent(() => import("../../../../../components/input/template-builder/select/CSelect"));

export const callHazObject = ({ searchQuery }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "refSpecies.key", type: "String", operator: "in", value: ["2", "3"] }
    ];
    if (searchQuery) {
        where.push({ name: "nameTh", type: "String", operator: "like", value: searchQuery });
        where.push({ logic: "OR", name: "nameEn", type: "String", operator: "like", value: searchQuery });
        where.push({ logic: "OR", name: "refSpecies.value", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/master/hazObject/search", {
            criteria: {
                select: ["*", "refSpecies.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [
                    { name: "nameTh", type: "ASC" },
                    { name: "refSpecies.seq", type: "ASC" }
                ]
            }
        })
        .then(page => page.data);
};
export const callHazDetailSubStanceType = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_DETAIL_SUB_STANCE_TYPE", value: searchQuery })
        .then(items => items.filter(d => ["1", "2"].includes(d.key)));
export const callCountry = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/country/cacheFindAll", {
        where: [
            { openBucket: true, name: "nameTh", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "nameEnS", type: "String", operator: "like", value: searchQuery }
        ],
        sort: [{ name: "seq", type: "ASC" }]
    });
export const callHazType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_TYPE", value: searchQuery });
export const callHazSubStanceType = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_SUB_STANCE_TYPE", value: searchQuery })
        .then(items => items.filter(d => ["chemi", "micro"].includes(d.key)));
export const callDepartment = ({ searchQuery }) => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "analyticalAgency", nameTh: searchQuery });
export const callAnalyticalMethod = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "ANALYTICAL_METHOD", value: searchQuery });
export const callHazSubStanceActive = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_SUB_STANCE_ACTIVE", value: searchQuery });
export const callHazSubStanceUnit = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_SUB_STANCE_UNIT", value: searchQuery });
export const callHazProductUse = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_PRODUCT_USE", value: searchQuery });

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refHazObject`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => `${i18n.global.t("model.haz.refHazObject")} (TH)`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refHazObject,
                                        "onUpdate:value": value => (model.refHazObject = value),
                                        disabled: viewOnly,
                                        list: callHazObject,
                                        optLabel: "nameTh",
                                        renderLabel: ({ item }) => {
                                            return (
                                                <div>
                                                    {item.nameTh} - {item.refSpecies?.value}
                                                </div>
                                            );
                                        }
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refHazObject.nameEn`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => `${i18n.global.t("model.haz.refHazObject")} (EN)`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refHazObject?.nameEn,
                                        "onUpdate:value": value => (model.refHazObject.nameEn = value),
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refHazObject.refSpecies.value`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazObject.refSpecies"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refHazObject?.refSpecies?.value,
                                        "onUpdate:value": value => (model.refHazObject.refSpecies.value = value),
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refSubStanceType`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.refSubStanceType"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refSubStanceType,
                                        "onUpdate:value": value => (model.refSubStanceType = value),
                                        disabled: viewOnly,
                                        list: callHazDetailSubStanceType,
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        createFieldTemplateBuilder({
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.hazInfo.nature"),
                            inputProp: () => ({
                                useForm: useForm,
                                fields: [
                                    createFieldCheckbox({
                                        visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                        key: `${prefix}isSolid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.isSolid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    checked: model.isSolid,
                                                    "onUpdate:checked": checked => {
                                                        model.isSolid = checked;
                                                        if (checked) {
                                                            model.isLiquid = false;
                                                            model.liquid = null;
                                                        }
                                                    },
                                                    disabled: viewOnly,
                                                    text: () => i18n.global.t("model.haz.isSolid")
                                                },
                                                conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                                            )
                                    }),
                                    createFieldInput({
                                        visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                        key: `${prefix}solid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.solid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    value: model.solid,
                                                    "onUpdate:value": value => (model.solid = value),
                                                    disabled: viewOnly || !model.isSolid
                                                },
                                                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                            )
                                    }),
                                    createFieldCheckbox({
                                        visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                        key: `${prefix}isLiquid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.isLiquid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    checked: model.isLiquid,
                                                    "onUpdate:checked": checked => {
                                                        model.isLiquid = checked;
                                                        if (checked) {
                                                            model.isSolid = false;
                                                            model.solid = null;
                                                        }
                                                    },
                                                    disabled: viewOnly,
                                                    text: () => i18n.global.t("model.haz.isLiquid")
                                                },
                                                conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                                            )
                                    }),
                                    createFieldInput({
                                        visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                        key: `${prefix}liquid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.liquid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    value: model.liquid,
                                                    "onUpdate:value": value => (model.liquid = value),
                                                    disabled: viewOnly || !model.isLiquid
                                                },
                                                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                            )
                                    })
                                ],
                                skeleton: isLoading.value
                            })
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}ph`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.ph"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.ph,
                                        "onUpdate:value": value => (model.ph = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        })
                    ],
                    skeleton: isLoading.value
                })
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}tradeNameTh`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.tradeNameTh"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.tradeNameTh,
                                        "onUpdate:value": value => (model.tradeNameTh = value),
                                        onBlur: () => useForm.validate(field.key).catch(() => {}),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}tradeNameEn`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.tradeNameEn"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.tradeNameEn,
                                        "onUpdate:value": value => (model.tradeNameEn = value),
                                        onBlur: () => useForm.validate(field.key).catch(() => {}),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}manufacturer`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.manufacturer"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.manufacturer,
                                        "onUpdate:value": value => (model.manufacturer = value),
                                        onBlur: () => useForm.validate([`${prefix}tradeNameTh`, `${prefix}tradeNameEn`]).catch(() => {}),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refManufactureCountry`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.refManufactureCountry"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refManufactureCountry,
                                        "onUpdate:value": value => {
                                            model.refManufactureCountry = value;
                                            useForm.validate([`${prefix}tradeNameTh`, `${prefix}tradeNameEn`]).catch(() => {});
                                        },
                                        disabled: viewOnly || model.refOperation?.key === "4",
                                        list: callCountry,
                                        renderLabel: ({ item }) => (
                                            <span>
                                                {item.nameEnS} : {item.nameTh}
                                            </span>
                                        )
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}approveCodeOld`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.approveCodeOld"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.approveCodeOld,
                                        "onUpdate:value": value => (model.approveCodeOld = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                    ],
                    skeleton: isLoading.value
                })
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.haz.refType"),
                inputProp: ({ field }) => {
                    let list = callHazType;
                    if (model.refOperation?.key === "4") {
                        list = ({ searchQuery }) => callHazType({ searchQuery }).then(items => items.filter(item => item.key === "2"));
                    }
                    return lodash.merge(
                        {
                            value: model.refType,
                            "onUpdate:value": value => {
                                model.refType = value;
                                if (value?.key === "1") {
                                    lodash.remove(model.products, d => !d.id);
                                    model.products.forEach(d => (d.isDelete = true));
                                } else if (value?.key === "2") {
                                    model.toUse = null;
                                }
                                useForm.validate([`${prefix}tradeNameTh`, `${prefix}tradeNameEn`]).catch(() => {});
                            },
                            disabled: viewOnly,
                            list,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}toUse`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.haz.toUse"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.toUse,
                            "onUpdate:value": value => (model.toUse = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}products`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("views.request.hazInfo.toUse"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.products,
                            "onUpdate:value": value => (model.products = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callHazProductUse({ searchQuery }).then(items => items.map(item => ({ refProduct: item }))),
                            // optLabel: "refProduct.value",
                            renderLabel: ({ item }) => (
                                <div>{item.refProduct?.value || ''} {item.refProduct?.refParent?.value ? `${item.refProduct.refParent.value}` : ''}</div>
                            ),
                            mode: "multiple",
                            optKey: "refProduct.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refProduct?.value }
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSubStanceTypeMain`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.haz.refSubStanceTypeMain"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSubStanceTypeMain,
                            "onUpdate:value": value => {
                                const oldValue = model.refSubStanceTypeMain;
                                model.refSubStanceTypeMain = value;
                                clearSubStanceMain({ modelRef, model });
                                if (
                                    (["micro"].includes(oldValue?.key) && !["micro"].includes(value?.key)) ||
                                    (!["micro"].includes(oldValue?.key) && ["micro"].includes(value?.key))
                                ) {
                                    model.mainSubStances.forEach(mainSubStance => {
                                        if (mainSubStance.refSubStance?.refType?.key !== "media") {
                                            mainSubStance.refSubStance = null;
                                        }
                                    });
                                }
                                if (!["chemi"].includes(value?.key)) {
                                    model.isTechnicalGrade = false;
                                }
                            },
                            disabled: viewOnly,
                            list: callHazSubStanceType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isTechnicalGrade`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 }, colon: false }),
                label: () => i18n.global.t("model.haz.isTechnicalGrade"),
                labelRender: () => " ",
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isTechnicalGrade,
                            "onUpdate:checked": checked => (model.isTechnicalGrade = checked),
                            disabled: viewOnly || !["chemi"].includes(model.refSubStanceTypeMain?.key),
                            text: () => i18n.global.t("model.haz.isTechnicalGrade")
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refAnalysisAgency`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.refAnalysisAgency"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refAnalysisAgency,
                            "onUpdate:value": value => (model.refAnalysisAgency = value),
                            disabled: viewOnly,
                            list: callDepartment,
                            optLabel: "nameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refAnalysisMethod`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.refAnalysisMethod"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refAnalysisMethod,
                            "onUpdate:value": value => (model.refAnalysisMethod = value),
                            disabled: viewOnly,
                            list: callAnalyticalMethod,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}mainSubStances`,
                            fetchCriteria: data.mainSubStance?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "HazMainSubStanceList" } })
                    );
                    return <HazMainSubStanceList {...componentProp}></HazMainSubStanceList>;
                }
            },
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isSubStanceActive`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 }, colon: false }),
                label: () => i18n.global.t("model.haz.isSubStanceActive"),
                labelRender: () => " ",
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isSubStanceActive,
                            "onUpdate:checked": checked => {
                                model.isSubStanceActive = checked;
                                if (!checked) {
                                    model.refSubStanceActive = null;
                                    model.subStanceMainQty = null;
                                    model.analysisResult = null;
                                    model.refSubStanceMainUnit = null;
                                }
                            },
                            disabled: viewOnly,
                            text: () => i18n.global.t("model.haz.isSubStanceActive")
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSubStanceActive`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.refSubStanceActive"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSubStanceActive,
                            "onUpdate:value": value => (model.refSubStanceActive = value),
                            disabled: viewOnly || !model.isSubStanceActive,
                            list: callHazSubStanceActive,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}subStanceMainQty`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.subStanceMainQty"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.subStanceMainQty,
                            "onUpdate:value": value => (model.subStanceMainQty = value),
                            disabled: viewOnly || !model.isSubStanceActive,
                            allowPrecision: true,
                            addonAfter: () => {
                                const addonAfterProp = lodash.merge(
                                    {
                                        value: model.refSubStanceMainUnit,
                                        "onUpdate:value": value => (model.refSubStanceMainUnit = value),
                                        disabled: viewOnly || !model.isSubStanceActive,
                                        list: callHazSubStanceUnit,
                                        optLabel: "value",
                                        placeholder: i18n.global.t("button.unit"),
                                        style: { width: "100px !important" }
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field: { key: `${prefix}refSubStanceMainUnit` } }
                                    })
                                );
                                return (
                                    <Form.Item {...useForm.validateInfos[`${prefix}refSubStanceMainUnit`]} help={undefined}>
                                        <CSelect {...addonAfterProp}></CSelect>
                                    </Form.Item>
                                );
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}analysisResult`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.analysisResult"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.analysisResult,
                            "onUpdate:value": value => (model.analysisResult = value),
                            disabled: viewOnly || !model.isSubStanceActive,
                            allowPrecision: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSubStanceActiveRate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.hazInfo.refSubStanceActiveRate"),
                inputProp: ({ field }) => {
                    // type must change from refSubStanceActive.isSolid = '1' or refSubStanceActive.isLiquid = '2'
                    const type = modelRef?.refHazTemp?.isLiquid === true ? "2" : "1";
                    const rate = calSubStanceRate({ type: type, qty: model.subStanceMainQty });
                    return lodash.merge(
                        {
                            value: rate ? `${rate.min} - ${rate.max}` : "",
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            })
        ]
    });
};

export const clearSubStanceMain = ({ modelRef, model }) => {
    if (
        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro", isTechnicalGrade: false })
    ) {
        model.mainSubStances.forEach(mainSubStance => {
            mainSubStance.isImport = null;
            lodash.remove(mainSubStance.companies, company => !company.id).forEach(company => (company.isDelete = true));
            lodash.remove(mainSubStance.products, product => !product.id).forEach(product => (product.isDelete = true));
            mainSubStance.isInternal = null;
            mainSubStance.docNoRefer = null;
            mainSubStance.attachments[0].url = null;
            mainSubStance.attachments[0].path = null;
            mainSubStance.attachments[0].name = null;
            mainSubStance.attachments[0].blob = null;
            mainSubStance.attachments[0].size = null;
            mainSubStance.attachments[0].type = null;
            mainSubStance.attachments[0].documentName = null;
        });
    }
    if (
        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true })
    ) {
        model.mainSubStances.forEach(mainSubStance => {
            mainSubStance.microAnalysisResult1 = null;
            mainSubStance.microAnalysisResult2 = null;
            mainSubStance.microAnalysisResult3 = null;
            mainSubStance.microAnalysisQty1 = null;
            mainSubStance.microAnalysisQty2 = null;
            mainSubStance.microAnalysisQty3 = null;
            mainSubStance.refMicroUnit = null;
            if (!mainSubStance.qty) {
                mainSubStance.refUnit = null;
            }
        });
    }
    if (
        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro" }) ||
        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro" })
    ) {
        model.mainSubStances.forEach(mainSubStance => {
            mainSubStance.chemiAnalysisResult = null;
            mainSubStance.isBypassAnalysisResult = null;
            mainSubStance.qty = null;
            mainSubStance.refUnit = null;
        });
    }
};
